import { useAppAvailabilityGet } from "@sportsmet/site-sdk/public";
import { Button, Card } from "@sportsmet/ui";
import { createFileRoute, Link } from "@tanstack/react-router";
import { useAuth } from "../auth/AuthProvider";
import { SectionScreen } from "../shell/SectionScreen";

function storeLink(value: unknown): string | null {
  if (typeof value !== "string") return null;
  try {
    const url = new URL(value);
    return url.protocol === "https:" ? url.href : null;
  } catch {
    return null;
  }
}
export function WelcomeScreen() {
  const { state } = useAuth();
  const availability = useAppAvailabilityGet({});
  const ios = storeLink(availability.data?.data?.iosStoreUrl);
  const android = storeLink(availability.data?.data?.androidStoreUrl);
  const signedIn = state.status === "signedIn";
  return (
    <SectionScreen heading="Welcome to Sportsmet">
      <Card>
        <div className="flex flex-col gap-4">
          <p>
            Sports pools, live scores, and friends. Join the fanbase and enjoy
            the games together.
          </p>
          <Button asChild>
            {signedIn ? (
              <Link to="/scores">Continue to Sportsmet</Link>
            ) : (
              <Link
                to="/sign-in"
                search={{ step: "email", redirect: "/scores" }}
              >
                Join Sportsmet on the web
              </Link>
            )}
          </Button>
          <p>
            {signedIn
              ? "Your account is ready to use on the web."
              : "New here? Signing in creates your account. Already a fan? Use the same sign-in."}
          </p>
          <h2 className="text-h2">Get the app</h2>
          {ios ? (
            <Button asChild variant="secondary">
              <a href={ios} rel="noopener noreferrer">
                Get it on the App Store
              </a>
            </Button>
          ) : null}
          {android ? (
            <Button asChild variant="secondary">
              <a href={android} rel="noopener noreferrer">
                Get it on Google Play
              </a>
            </Button>
          ) : null}
          <p role="status">
            {availability.isPending
              ? "Checking app availability…"
              : !ios && !android
                ? "App downloads aren't available here yet. You can join and play on the web."
                : "You can also keep using Sportsmet on the web."}
          </p>
        </div>
      </Card>
    </SectionScreen>
  );
}
export const Route = createFileRoute("/get-started")({
  component: WelcomeScreen,
});
